import { render, staticRenderFns } from "./HowUseCatalog.vue?vue&type=template&id=5fd9b812&scoped=true"
import script from "./HowUseCatalog.vue?vue&type=script&lang=ts"
export * from "./HowUseCatalog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd9b812",
  null
  
)

export default component.exports